<template>
    <div style="width: 100%;height: 100%">
        <!-- 卡片视图 -->
        <el-card>
             <div style="display: flex">
               <el-col>
                    <el-button type="primary" @click="create">员工入库</el-button>
                </el-col>
                <el-button type="primary"  @click="downloadAnnex()" style="margin-left: auto">
                    下载分组员工信息
                </el-button>
            </div>
            <el-table :data="goodsList" border stripe v-loading="loading">
                <el-table-column type="index"></el-table-column>
                <el-table-column label="姓名" prop="name" ></el-table-column>
                <el-table-column label="身份证号" prop="idno" ></el-table-column>
                <el-table-column label="省" prop="province" ></el-table-column>
                <el-table-column label="市" prop="city" ></el-table-column>
                <el-table-column label="描述" prop="desc" ></el-table-column>
              <el-table-column label="支付宝账户" prop="logon_id" ></el-table-column>
                <el-table-column label="电话" prop="phone" ></el-table-column>
                <el-table-column label="创建时间" prop="create_time" >
                    <template slot-scope="scope">{{scope.row.create_time| dataFormat}}</template>
                </el-table-column>
                <el-table-column label="更新时间" prop="update_time" >
                    <template slot-scope="scope">{{scope.row.update_time | dataFormat }}</template>
                </el-table-column>
                <el-table-column label="操作" >
                    <template slot-scope="scope">
                        <el-button type="primary" icon="el-icon-edit" size="mini"  @click="toDetail(scope.row.id)">查看详情</el-button>
                        <el-button type="danger" icon="el-icon-delete" size="mini"  @click="toDelete(scope.row.id)" style="margin-top: 10px" v-if="identity==='ad'">移除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页区域 -->
            <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="queryInfo.pagenum"
                    :page-sizes="[5, 10, 15, 20]"
                    :page-size="queryInfo.pagesize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total"
                    background
            ></el-pagination>
        </el-card>
        <div  v-if="isOpen">
            <div class="wrap2" @click="close()"></div>
            <div class="form2">
                <vue-qr :text="url" :size="200" :margin="0" :logoMargin="2"></vue-qr>
                <div>{{msg}}</div>
            </div>
        </div>
    </div>
</template>

<script>
    import vueQr from 'vue-qr'
    export default {
        data () {
            return {
                queryInfo: {
                    query: '',
                    pagenum: 1,
                    pagesize: 10
                },
                // 商品列表
                goodsList: [
                ],
                id:0,
                identity:"",
                demo:"",
                // 商品总数
                total: 0,
                offset:0,
                oldoffset:0,
                isOpen:false,
                info:{
                    name:"",
                    desc:"",
                    phone:""
                },
                loading:true,
                input: '',
                selectname: 'name',
                msg:""
            }
        },
        components: {
            vueQr
        },
        created(){
            this.id = this.$route.params.id
            this.identity = this.$route.params.identity
            this.getList();
        },
        methods:{
            async getList(){
                let that=this;
                const { data: res } = await this.$http.post('',
                    {
                       "oper": "get_multi_staff",
                        "ent": "task",
                        "info": {
                            "task_id":this.id,
                            "count":this.queryInfo.pagesize,
                            "offset":this.offset,
                        }
                    }
                )
                console.log(res)
                if(res.code==0) {
                    this.goodsList = res.data.data_list;
                    that.total = res.data.total_count;
                    this.oldoffset = this.offset;
                    this.offset += this.queryInfo.pagesize
                }else{
                    this.$message(res.msg);
                }
                this.loading=false;
            },

            handleCurrentChange (newSize) {
                this.queryInfo.pagenum = newSize;
                this.offset=(newSize-1)*this.queryInfo.pagesize;
                this.oldoffset=this.offset;
                this.getList()
            },
            handleSizeChange (newSize) {
                this.queryInfo.pagesize = newSize
                this.offset=0
                this.oldoffset=this.offset;
                this.getList()
            },

            async create(){
                const { data: res } = await this.$http.post('',
                    {
                       "oper": "get_by_id",
                        "ent": "task",
                        "info": {
                            "id":this.id,
                        }

                    }
                )
                console.log(res)
                if(res.code==0){
                    this.url=res.data.collect_staff_url;
                    this.msg=res.data.task_wenan;
                    this.isOpen=true;
                }
                else{
                    this.$message(res.msg);
                }

            },
            toDetail(id){
                console.log(id)
                this.$router.push({ name: 'staff-detail', params: { id: id }});
            },

            async download(){
                const { data: res } = await this.$http.post('',
                    {
                        "oper": "task_staff_url",
                        "ent": "task",
                        "info": {
                             "task_id":this.id,
                        }

                    }
                )
                if(res.code==0){
                    this.demo=res.data.url;
                }else{
                    this.$message(res.msg);
                }
                console.log(res)
            },
             downloadAnnex(){
                let that=this;
                Promise.resolve(this.download()).then(function () {
                    console.log(that.demo)
                    if(that.demo.length>0) {
                        const aTag = document.createElement('a')
                        aTag.href = that.demo;
                        aTag.click()
                    }
                });
            },
            close(){
                this.isOpen=false;
            },
             toDelete(id){
                 var sidlist=[id];
                this.$confirm('此操作将移除，是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async() => {
                    const { data: res } = await this.$http.post('',
                        {
                            "oper": "del_staff",
                            "ent": "task",
                            "info": {
                                "task_id":this.id,
                                sidlist
                            }
                        }
                    )
                    console.log(res)
                    if(res.code==0) {
                        this.$message(res.msg);
                        this.offset = this.oldoffset;
                        this.getList();
                    } else{
                        this.$message({
                            message:res.msg,
                            duration:6000
                        });
                    }
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },

        }
    }
</script>

<style>
    .wrap2{
            position:fixed;
            left:0px;
            top:0px;
            background:rgba(0, 0, 0, 0.4);
            width:100%;  /*宽度设置为100%，这样才能使隐藏背景层覆盖原页面*/
            height:100%;
            filter:alpha(opacity=60);  /*设置透明度为60%*/
            opacity:0.6;  /*非IE浏览器下设置透明度为60%*/
            z-Index:9;
        }
    .qrcode{
        display: inline-block;
    }
    .qrcode img {
        width: 132px;
        height: 132px;
        background-color: #fff;
        padding: 6px;
        box-sizing: border-box;
    }
    .select{
        height: 125px !important;
    }
    .form2{
        width:350px;
        border-radius: 20px;
        border:#909399 solid;
        box-sizing: border-box;
        padding: 15px;
        top:50%;
        left:50%;
        position: absolute;
        transform: translate(-50%,-50%);
        background: white;
        z-index: 999;
          display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
</style>
